<app-modal-base [title]="dialogTitle" [hasSubmit]="false" cancelType="CLOSE">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div *ngIf="stats">
      <p>
        <span class="title">Bien:</span><span>{{ data.share.property.name }}</span>
      </p>
      <p *ngIf="targetUserName">
        <span class="title">Destinataire:</span><span>{{ targetUserName }}</span>
      </p>
      <p *ngIf="data.share.visitMode">
        <span class="title">Bon de visite accepté le:</span><span>{{ data.share.visitAcknowledged ?
          (data.share.visitAcknowledgeDate |
          dateTimeFormat) : 'Jamais' }}</span>
      </p>
      <p>
        <span class="title">Nombre de vues:</span><span>{{ stats.views }}</span>
      </p>
      <p>
        <span class="title">Dernières vues:</span>
      </p>
      <ul>
        <li *ngFor="let date of stats.dates">
          {{ date | dateTimeFormat }}
        </li>
      </ul>
      <p *ngIf="data.share.visitMode && !data.share.visitAcknowledged && stats.views>0"
        class="alert alert-warning no-details">Le bon de visite
        n'ayant pas été validé, les détails du bien n'ont pas été montrés.</p>
    </div>
  </div>
</ng-template>